import { cva, type VariantProps } from 'class-variance-authority';
import { BoxIcon, Coins, Boxes, Ticket, type LucideIcon } from 'lucide-react';

import { AppTooltip } from '@/components/appTooltip';
import { cn } from '@/lib/utils';

const itemTypeVariants = cva('', {
  variants: {
    variant: {
      default: 'text-rarity-border dark:text-rarity-text',
      bordered: 'text-rarity-border bg-rarity-label shrink-0 rounded-lg p-1',
    },
  },
  defaultVariants: { variant: 'default' },
});

const ICONS: Record<string, LucideIcon> = {
  item: BoxIcon,
  bundle: Boxes,
  currency: Coins,
  season_pass: Ticket,
};

export const ItemType = ({
  type,
  item_rarity,
  size = 64,
  variant,
  className,
}: {
  type: string;
  item_rarity?: string;
  size?: number;
  variant?: VariantProps<typeof itemTypeVariants>['variant'];
  className?: string;
}) => {
  const strokeWidth = size > 32 ? 1 : 2.5;
  const rarity = item_rarity?.toLowerCase();
  // Self-apply the rarity context so the `rarity-*` utilities
  // resolve without an ancestor. Bordered always needs a chip bg, so it falls
  // back to `common`; a bare default with no rarity inherits its color.
  const rarityClass = rarity
    ? `rarity-${rarity}`
    : variant === 'bordered'
      ? 'rarity-common'
      : undefined;
  const Icon = ICONS[type];

  return (
    <div className={cn(itemTypeVariants({ variant }), rarityClass, className)}>
      <AppTooltip title={`${rarity ?? ''} ${type}`}>
        <div>
          {Icon && (
            <Icon
              size={size}
              strokeWidth={strokeWidth}
              className="self-center justify-self-center"
            />
          )}
        </div>
      </AppTooltip>
    </div>
  );
};
